// extracted by mini-css-extract-plugin
export default {"controller":"PageController-module__controller___Ij4dd","buttonWrapper":"PageController-module__buttonWrapper___FL4c5"};